module.exports = __webpack_public_path__ + "static/media/thin floor fade.2163dd15.png";